// @auto-index

import apiKeyCreated from './api-key-created.jpg'
import apiLibrary from './api-library.jpg'
import apiServicesMenu from './api-services-menu.jpg'
import authorize from './authorize.jpg'
import beforeSend from './before-send.jpg'
import createPrompt from './create-prompt.jpg'
import credentials from './credentials.jpg'
import exchange from './exchange.jpg'
import gmailApiEnable from './gmail-api-enable.jpg'
import gmailApi from './gmail-api.jpg'
import incoming from './incoming.jpg'
import newProject from './new-project.jpg'
import oauthClient from './oauth-client.jpg'
import result from './result.jpg'
import sent from './sent.jpg'

export { default as apiKeyCreated } from './api-key-created.jpg'
export { default as apiLibrary } from './api-library.jpg'
export { default as apiServicesMenu } from './api-services-menu.jpg'
export { default as authorize } from './authorize.jpg'
export { default as beforeSend } from './before-send.jpg'
export { default as createPrompt } from './create-prompt.jpg'
export { default as credentials } from './credentials.jpg'
export { default as exchange } from './exchange.jpg'
export { default as gmailApiEnable } from './gmail-api-enable.jpg'
export { default as gmailApi } from './gmail-api.jpg'
export { default as incoming } from './incoming.jpg'
export { default as newProject } from './new-project.jpg'
export { default as oauthClient } from './oauth-client.jpg'
export { default as result } from './result.jpg'
export { default as sent } from './sent.jpg'

export default {
  apiKeyCreated,
  apiLibrary,
  apiServicesMenu,
  authorize,
  beforeSend,
  createPrompt,
  credentials,
  exchange,
  gmailApiEnable,
  gmailApi,
  incoming,
  newProject,
  oauthClient,
  result,
  sent
}
